import React from 'react';
import { Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ReportFinalizeActionsProps {
  isSaving: boolean;
  onFinalizeClose: () => void;
  onFinalizeSend: () => void;
  onDelete?: () => void;
  errorMessage?: string;
}

export const ReportFinalizeActions: React.FC<ReportFinalizeActionsProps> = ({
  isSaving,
  onFinalizeClose,
  onFinalizeSend,
  onDelete,
  errorMessage = '',
}) => (
  <div className="space-y-3">
    {errorMessage && (
      <p className="text-sm text-red-500 text-right">{errorMessage}</p>
    )}
    <div className="flex items-center justify-between gap-4">
      {onDelete ? (
        <Button
          type="button"
          variant="outline"
          onClick={onDelete}
          disabled={isSaving}
          className="text-red-600 border-red-200 hover:bg-red-50 hover:text-red-700 hover:border-red-300 flex items-center gap-2"
        >
          <Trash2 className="w-4 h-4 shrink-0" />
          Excluir report
        </Button>
      ) : (
        <div />
      )}
      <div className="flex items-center gap-3">
        <Button
          type="button"
          variant="outline"
          onClick={onFinalizeClose}
          disabled={isSaving}
        >
          {isSaving ? 'Finalizando...' : 'Finalizar e fechar'}
        </Button>
        <Button
          type="button"
          variant="dark"
          onClick={onFinalizeSend}
          disabled={isSaving}
        >
          {isSaving ? 'Finalizando...' : 'Finalizar e enviar'}
        </Button>
      </div>
    </div>
  </div>
);
